import React from 'react';
import { Plus, X, Loader2 } from 'lucide-react';

export default function MealSlotOptionFilterBar({
  options = [],
  selectedOption,
  onSelectOption,
  includeAll = false,
  onAddOptionClick,
  onDeleteOption,
  deletingOption,
  disabled = false,
  addOptionLabel = 'Add option',
  addOptionClassName = '',
  buttonClassName = 'px-3 py-1 rounded-md font-medium text-sm',
  activeClassName = 'bg-orange-primary text-white',
  inactiveClassName = 'bg-gray-100 text-gray-700 hover:bg-gray-200',
  allActiveClassName,
  allInactiveClassName,
}) {
  const active = activeClassName;
  const inactive = inactiveClassName;
  const allActive = allActiveClassName || active;
  const allInactive = allInactiveClassName || inactive;

  return (
    <div className={`flex gap-2 flex-wrap items-center ${addOptionClassName}`.trim()}>
      {includeAll && (
        <button
          type="button"
          onClick={() => onSelectOption('all')}
          disabled={disabled}
          className={`${buttonClassName} transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
            selectedOption === 'all' ? allActive : allInactive
          }`}
        >
          All
        </button>
      )}
      {options.map((optNum) => {
        const isActive = selectedOption === String(optNum);
        const isDeleting = deletingOption === String(optNum);
        return (
          <div
            key={optNum}
            className={`inline-flex items-center gap-1 ${buttonClassName} transition-colors ${
              disabled ? 'opacity-50' : ''
            } ${isActive ? active : inactive}`}
          >
            <button
              type="button"
              onClick={() => onSelectOption(String(optNum))}
              disabled={disabled}
              className="focus:outline-none focus:ring-0 disabled:cursor-not-allowed"
            >
              Option {optNum}
            </button>
            {isActive && onDeleteOption && (
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  onDeleteOption(optNum);
                }}
                disabled={isDeleting || disabled}
                aria-label={`Delete Option ${optNum}`}
                className="rounded-full hover:bg-black/10 p-0.5 disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-0"
              >
                {isDeleting ? (
                  <Loader2 className="w-3.5 h-3.5 animate-spin" />
                ) : (
                  <X className="w-3.5 h-3.5" />
                )}
              </button>
            )}
          </div>
        );
      })}
      {onAddOptionClick && (
        <button
          type="button"
          onClick={onAddOptionClick}
          disabled={disabled}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-md border-2 border-dashed border-gray-300 text-gray-600 hover:border-orange-primary hover:text-orange-primary transition-colors text-sm font-medium focus:outline-none focus:ring-0 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <Plus className="w-4 h-4" />
          {addOptionLabel}
        </button>
      )}
    </div>
  );
}
